import IntrusionDetectionEventIcon from "../../src/assets/EventIcons/Intrusion-Event-Icon.svg";
import DoorOpenEventIcon from "../../src/assets/EventIcons/Door-open-Event-Icon.svg";
import ObjectDetectedEventIcon from "../../src/assets/EventIcons/Object-detection-Event-Icon.svg";
import SmokeAndFireEventIcon from "../../src/assets/EventIcons/Smoke-and-fire-Event-Icon.svg";
import RestrictedAreaEventIcon from "../../src/assets/EventIcons/Restricted-Area-Event-Icon.svg";
import ErrorNotificationIcon from "../../src/assets/error.svg";
import InfoNotificationIcon from "../../src/assets/info.svg";
import WarningNotificationIcon from "../../src/assets/warning.svg";

import doorOpenBlue from "../../src/assets/EventIcons/Blue/door-open.svg";
import doorOpenOrange from "../../src/assets/EventIcons/Orange/door-open.svg";
import restrictedAreaBlue from "../../src/assets/EventIcons/Blue/restricted-area.svg";
import restrictedAreaOrange from "../../src/assets/EventIcons/Orange/restricted-area.svg";
import fireBlue from "../../src/assets/EventIcons/Blue/fire.svg";
import fireOrange from "../../src/assets/EventIcons/Orange/fire.svg";
import peopleCountingBlue from "../../src/assets/EventIcons/Blue/people-counting.svg";
import peopleCountingOrange from "../../src/assets/EventIcons/Orange/people-counting.svg";
import objectDetectionOrange from "../../src/assets/EventIcons/Orange/object-detection.svg";
import objectDetectionBlue from "../../src/assets/EventIcons/Blue/object-detection.svg";
import slipAndFallOrange from "../../src/assets/EventIcons/Orange/slip_and_fall.svg";
import slipAndFallBlue from "../../src/assets/EventIcons/Blue/slip-and-fall.svg";
import newDwellTimeOrange from "../../src/assets/EventIcons/Orange/EBC-dwell-time.svg";
import newPeopleCounting from "../../src/assets/EventIcons/Orange/EBC-people-counting.svg";
import newRestrictedArea from "../../src/assets/EventIcons/Orange/EBC-restricted-area.svg";
import newSlipAndFall from "../../src/assets/EventIcons/Orange/EBC-slip-and-fall.svg";
import newOpenDoor from "../../src/assets/EventIcons/Orange/EBC-open-door.svg";

import newCriticalPeopleCount from "../../src/assets/EventIcons/Orange/peoplecount-critical.svg";
import newCriticalVehiclecCount from "../../src/assets/EventIcons/Orange/vehiclecount-critical.svg";
import newCriticalParkingoccupancy from "../../src/assets/EventIcons/Orange/parkingoccupancy-critical.svg";
import newCriticalPersonorVehicle from "../../src/assets/EventIcons/Orange/personorvehicle-critical.svg";
import newCriticalPPE from "../../src/assets/EventIcons/Orange/ppe-critical.svg";
import newCriticalUnattendedObject from "../../src/assets/EventIcons/Orange/unattendedobject-critical.svg";
import newCriticalProximity from "../../src/assets/EventIcons/Orange/proximity-detection-critical.svg";
import newCriticalStreamMonitoring from "../../src/assets/EventIcons/Orange/streammonitoring-critical.svg";
import newCriticalSlipFall from "../../src/assets/EventIcons/Orange/slip-and-fall-critical.svg";
import newCriticalCrowdcounting from "../../src/assets/EventIcons/Orange/crowdcounting-critical.svg";
import newCriticalDwellTime from "../../src/assets/EventIcons/Orange/dwelltime-critical.svg";
import newCriticalObjectDetection from "../../src/assets/EventIcons/Orange/objectdetection-critical.svg";
import newCriticalPersonDetection from "../../src/assets/EventIcons/Orange/persondetection-critical.svg";
import newCriticalVehicleDetection from "../../src/assets/EventIcons/Orange/vehicle-critical.svg";

import newMinorPeopleCount from "../../src/assets/EventIcons/Blue/peoplecount-minor.svg";
import newMinorVehiclecCount from "../../src/assets/EventIcons/Blue/vehiclecount-minor.svg";
import newMinorParkingoccupancy from "../../src/assets/EventIcons/Blue/parkingoccupancy-minor.svg";
import newMinorPersonorVehicle from "../../src/assets/EventIcons/Blue/personorvehicle-minor.svg";
import newMinorPersonDetection from "../../src/assets/EventIcons/Blue/persondetection-minor.svg";
import newMinorVehicleDetection from "../../src/assets/EventIcons/Blue/vehicle-minor.svg";
import newMinorPPE from "../../src/assets/EventIcons/Blue/ppe-minor.svg";
import newMinorUnattendedObject from "../../src/assets/EventIcons/Blue/unattendedobject-minor.svg";
import newMinorProximity from "../../src/assets/EventIcons/Blue/proximity-detection-minor.svg";
import newMinorStreamMonitoring from "../../src/assets/EventIcons/Blue/streammonitoring-minor.svg";
import newMinorSlipFall from "../../src/assets/EventIcons/Blue/slip-and-fall-minor.svg";
import newMinorCrowdcounting from "../../src/assets/EventIcons/Blue/crowdcounting-minor.svg";
import newMinorDwellTime from "../../src/assets/EventIcons/Blue/dwelltime-minor.svg";
import newMinorObjectDetection from "../../src/assets/EventIcons/Blue/objectdetection-minor.svg";
import CameraIconEBC from "../../src/assets/EventIconsEBC/camera-icon.svg";

//new icons which are required for EBC
import criticalDwellTime from "../../src/assets/EventIconsEBC/Orange/dwell-time.svg";
import criticalObjectDetection from "../../src/assets/EventIconsEBC/Orange/object-detection.svg";
import criticalOpenDoor from "../../src/assets/EventIconsEBC/Orange/open-door.svg";
import criticalPeopleCount from "../../src/assets/EventIconsEBC/Orange/people-count.svg";
import criticalRestrictedArea from "../../src/assets/EventIconsEBC/Orange/restricted-area.svg";
import criticalSlipAndFall from "../../src/assets/EventIconsEBC/Orange/slip-and-fall.svg";
import minorDwellTime from "../../src/assets/EventIconsEBC/Blue/dwell-time.svg";
import minorObjectDetection from "../../src/assets/EventIconsEBC/Blue/object-detection.svg";
import minorOpenDoor from "../../src/assets/EventIconsEBC/Blue/open-door.svg";
import minorPeopleCount from "../../src/assets/EventIconsEBC/Blue/people-count.svg";
import minorRestrictedArea from "../../src/assets/EventIconsEBC/Blue/restricted-area.svg";
import minorSlipAndFall from "../../src/assets/EventIconsEBC/Blue/slip-and-fall.svg";

import peopleCountOrange from "../../src/assets/EventIcons/Hover orange/People counting Orange.svg";
import vehicleCountOrange from "../../src/assets/EventIcons/Hover orange/Vehicle counting Orange.svg";
import parkingOccupancyOrange from "../../src/assets/EventIcons/Hover orange/Parking occupancy Orange.svg";
import crowdCountingOrange from "../../src/assets/EventIcons/Hover orange/Crowd counting Orange.svg";
import dwellTimeOrange from "../../src/assets/EventIcons/Hover orange/Dwell time Orange.svg";
import slipAndFallOrangeE from "../../src/assets/EventIcons/Hover orange/Slip and Fall Orange.svg";
import ppeOrange from "../../src/assets/EventIcons/Hover orange/PPE orange.svg";
import objectDetectionOrangeE from "../../src/assets/EventIcons/Hover orange/Object detection Orange.svg";
import unattendedObjectOrange from "../../src/assets/EventIcons/Hover orange/Unattended object Orange.svg";
import proximityDetectionOrange from "../../src/assets/EventIcons/Hover orange/Proximity detection Orange.svg";
import streamMonitoringOrange from "../../src/assets/EventIcons/Hover orange/Stream monitoring Orange.svg";
import peopleDetectionOrangeE from "../../src/assets/EventIcons/Hover orange/Person detection Orange.svg";
import vehicleDetectionOrangeE from "../../src/assets/EventIcons/Hover orange/Vehicle detection Orange.svg";

//Objects
import purseOrange from "../../src/assets/EventIcons/objects/Purse/object-purse-critical.svg";
import purseBlue from "../../src/assets/EventIcons/objects/Purse/object-purse-minor.svg";
import purseHover from "../../src/assets/EventIcons/objects/Purse/object-purse-critical-hover.svg";

import backpackOrange from "../../src/assets/EventIcons/objects/Backpack/object-backpack-critical.svg";
import backpackBlue from "../../src/assets/EventIcons/objects/Backpack/object-backpack-minor.svg";
import backpackHover from "../../src/assets/EventIcons/objects/Backpack/object-backpack-critical-hover.svg";

import bicycleOrange from "../../src/assets/EventIcons/objects/Bicycle/object-bike-critical.svg";
import bicycleBlue from "../../src/assets/EventIcons/objects/Bicycle/object-bike-minor.svg";
import bicycleHover from "../../src/assets/EventIcons/objects/Bicycle/object-bike-critical-hover.svg";

import boxOrange from "../../src/assets/EventIcons/objects/Box/object-box-critical.svg";
import boxBlue from "../../src/assets/EventIcons/objects/Box/object-box-minor.svg";
import boxHover from "../../src/assets/EventIcons/objects/Box/object-box-critical-hover.svg";

import busOrange from "../../src/assets/EventIcons/objects/Bus/object-bus-critical.svg";
import busBlue from "../../src/assets/EventIcons/objects/Bus/object-bus-minor.svg";
import busHover from "../../src/assets/EventIcons/objects/Bus/object-bus-critical-hover.svg";

import carOrange from "../../src/assets/EventIcons/objects/Car/object-car-critical.svg";
import carBlue from "../../src/assets/EventIcons/objects/Car/object-car-minor.svg";
import carHover from "../../src/assets/EventIcons/objects/Car/object-car-critical-hover.svg";

import cellphoneOrange from "../../src/assets/EventIcons/objects/Cell phone/object-phone-critical.svg";
import cellphoneBlue from "../../src/assets/EventIcons/objects/Cell phone/object-phone-minor.svg";
import cellphoneHover from "../../src/assets/EventIcons/objects/Cell phone/object-phone-critical-hover.svg";

import dogOrange from "../../src/assets/EventIcons/objects/Dog/object-dog-critical.svg";
import dogBlue from "../../src/assets/EventIcons/objects/Dog/object-dog-minor.svg";
import dogHover from "../../src/assets/EventIcons/objects/Dog/object-dog-critical-hover.svg";

import extinguisherOrange from "../../src/assets/EventIcons/objects/Extinguisher/object-extinguisher-critical.svg";
import extinguisherBlue from "../../src/assets/EventIcons/objects/Extinguisher/object-extinguisher-minor.svg";
import extinguisherHover from "../../src/assets/EventIcons/objects/Extinguisher/object-extinguisher-critical-hover.svg";

import forkliftOrange from "../../src/assets/EventIcons/objects/Forklift/object-forklift-critical.svg";
import forkliftBlue from "../../src/assets/EventIcons/objects/Forklift/object-forklift-minor.svg";
import forkliftHover from "../../src/assets/EventIcons/objects/Forklift/object-forklift-critical-hover.svg";

import laptopOrange from "../../src/assets/EventIcons/objects/Laptop/object-laptop-critical.svg";
import laptopBlue from "../../src/assets/EventIcons/objects/Laptop/object-laptop-minor.svg";
import laptopHover from "../../src/assets/EventIcons/objects/Laptop/object-laptop-critical-hover.svg";

import licensePlateOrange from "../../src/assets/EventIcons/objects/License plate/object-licenseplate-critical.svg";
import licensePlateBlue from "../../src/assets/EventIcons/objects/License plate/object-licenseplate-minor.svg";
import licensePlateHover from "../../src/assets/EventIcons/objects/License plate/object-licenseplate-critical-hover.svg";

import motorcycleOrange from "../../src/assets/EventIcons/objects/Motorcycle/object-motorcycle-critical.svg";
import motorcycleBlue from "../../src/assets/EventIcons/objects/Motorcycle/object-motorcycle-minor.svg";
import motorcycleHover from "../../src/assets/EventIcons/objects/Motorcycle/object-motorcycle-critical-hover.svg";

import strollerOrange from "../../src/assets/EventIcons/objects/Stroller/object-stroller-critical.svg";
import strollerBlue from "../../src/assets/EventIcons/objects/Stroller/object-stroller-minor.svg";
import strollerHover from "../../src/assets/EventIcons/objects/Stroller/object-stroller-critical-hover.svg";

import suitcaseOrange from "../../src/assets/EventIcons/objects/Suitcase/object-suitcase-critical.svg";
import suitcaseBlue from "../../src/assets/EventIcons/objects/Suitcase/object-suitcase-minor.svg";
import suitcaseHover from "../../src/assets/EventIcons/objects/Suitcase/object-suitcase-critical-hover.svg";

import truckOrange from "../../src/assets/EventIcons/objects/Truck/object-truck-critical.svg";
import truckBlue from "../../src/assets/EventIcons/objects/Truck/object-truck-minor.svg";
import truckHover from "../../src/assets/EventIcons/objects/Truck/object-truck-critical-hover.svg";

import vanOrange from "../../src/assets/EventIcons/objects/Van/object-van-critical.svg";
import vanBlue from "../../src/assets/EventIcons/objects/Van/object-van-minor.svg";
import vanHover from "../../src/assets/EventIcons/objects/Van/object-van-critical-hover.svg";

import wheelchairOrange from "../../src/assets/EventIcons/objects/Wheelchair/object-wheelchair-critical.svg";
import wheelchairBlue from "../../src/assets/EventIcons/objects/Wheelchair/object-wheelchair-minor.svg";
import wheelchairHover from "../../src/assets/EventIcons/objects/Wheelchair/object-wheelchair-critical-hover.svg";

// Maps API objectType values (inconsistent case/names) to icon map keys (Title Case)
const OBJECT_TYPE_NORMALIZE_MAP = {
  motorbike: "Motorcycle",
};

const normalizeObjectType = (objectType) => {
  if (!objectType) return null;
  const lower = objectType.toLowerCase();
  if (OBJECT_TYPE_NORMALIZE_MAP[lower]) return OBJECT_TYPE_NORMALIZE_MAP[lower];
  // Default: ensure Title Case (fixes "suitcase" → "Suitcase", "SUITCASE" → "Suitcase", etc.)
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

const objectDetectionIcons = {
  orange: {
    Handbag: purseOrange,
    Backpack: backpackOrange,
    Bicycle: bicycleOrange,
    "Cardboard Box": boxOrange,
    Bus: busOrange,
    Car: carOrange,
    "Mobile Phone": cellphoneOrange,
    Dog: dogOrange,
    Extinguisher: extinguisherOrange,
    Forklift: forkliftOrange,
    Laptop: laptopOrange,
    "License Plate": licensePlateOrange,
    Motorcycle: motorcycleOrange,
    Stroller: strollerOrange,
    Suitcase: suitcaseOrange,
    Truck: truckOrange,
    Van: vanOrange,
    Wheelchair: wheelchairOrange,
  },
  minor: {
    Handbag: purseBlue,
    Backpack: backpackBlue,
    Bicycle: bicycleBlue,
    "Cardboard Box": boxBlue,
    Bus: busBlue,
    Car: carBlue,
    "Mobile Phone": cellphoneBlue,
    Dog: dogBlue,
    Extinguisher: extinguisherBlue,
    Forklift: forkliftBlue,
    Laptop: laptopBlue,
    "License Plate": licensePlateBlue,
    Motorcycle: motorcycleBlue,
    Stroller: strollerBlue,
    Suitcase: suitcaseBlue,
    Truck: truckBlue,
    Van: vanBlue,
    Wheelchair: wheelchairBlue,
  },
  hover: {
    Handbag: purseHover,
    Backpack: backpackHover,
    Bicycle: bicycleHover,
    "Cardboard Box": boxHover,
    Bus: busHover,
    Car: carHover,
    "Mobile Phone": cellphoneHover,
    Dog: dogHover,
    Extinguisher: extinguisherHover,
    Forklift: forkliftHover,
    Laptop: laptopHover,
    "License Plate": licensePlateHover,
    Motorcycle: motorcycleHover,
    Stroller: strollerHover,
    Suitcase: suitcaseHover,
    Truck: truckHover,
    Van: vanHover,
    Wheelchair: wheelchairHover,
  },
};
export const getFloorsDropdownList = (floorsList) => {
  return floorsList.map((s, i) => (
    <option value={s.id} key={`floors_${i + 1}`}>
      {s.name}
    </option>
  ));
};

export const getSitesDropdownList = (sitesList) => {
  return sitesList.map((s, i) => (
    <option value={s.id} key={`sites_${i + 1}`}>
      {s.name}
    </option>
  ));
};

export const getEventsDropdownList = (allEvents) => {
  console.log(allEvents, "allev");
  if (allEvents && allEvents.length) {
    return allEvents.map((applicationId, index) => (
      <option key={`events_${index + 1}`}>
        {applicationId === "IntrusionDetection"
          ? "Restricted Area"
          : applicationId}
      </option>
    ));
  } else {
    return [];
  }
};
export const getSiteCritical = (siteId, allEvents) => {
  const matchedTags = [];
  //const matchedEvent = [];
  const camerasList = JSON.parse(sessionStorage.getItem("camerasList")) || [];
  const camerafilteredList = camerasList.filter(
    (item) => item?.tagids?.indexOf(siteId) !== -1
  );
  //console.log(camerasList, camerafilteredList, "camerafilteredList >>>>");
  if (!camerafilteredList) return [];
  const deviceList = JSON.parse(sessionStorage.getItem("deviceList")) || [];
  camerafilteredList.map((c) => {
    const matchedDevices = deviceList.filter((d) => d.parentdeviceid === c.id);

    matchedDevices?.map((m) => {
      const event = allEvents?.find(({ evidences }) =>
        evidences?.some(({ sourceId }) => sourceId === m.id)
      );
      // console.log(m.id, event, "matchedDevices >>>");
      if (event !== undefined) {
        matchedTags.push(event);
      }
    });
  });
  return matchedTags.length > 0 ? matchedTags : null;
};

export const getSiteCriticalMax = (allEvents) => {
  const matchedTags = [];
  allEvents.map((event) => {
    const deviceList = JSON.parse(sessionStorage.getItem("deviceList")) || [];
    const parentDevice = deviceList.find(
      ({ uid }) => uid === event["evidences"][0].sourceId
    );

    if (!parentDevice) return null;

    const dataList = deviceList.find(
      ({ id }) => id === parentDevice.parentdeviceid
    );

    if (!dataList || !dataList.tagids || dataList.tagids.length === 0)
      return null;

    const tagList = JSON.parse(sessionStorage.getItem("TagIdsList")) || [];

    dataList.tagids.map((id) => {
      const matchedTag = tagList.find(
        (tag) => tag.id === id && tag.kind === "ts.tag.floor"
      );
      if (matchedTag) {
        matchedTags.push(matchedTag);
      }
    });
  });

  let countOfCritical = [];

  matchedTags.forEach((x) => {
    if (
      countOfCritical.some((val) => {
        return val["id"] == x["id"];
      })
    ) {
      countOfCritical.forEach((k) => {
        if (k["id"] === x["id"]) {
          k["count"]++;
        }
      });
    } else {
      let a = {};
      a["id"] = x["id"];
      a["count"] = 1;
      countOfCritical.push(a);
    }
  });
  const maxEvent = Math.max(...countOfCritical.map((o) => o.count));
  const maxCritical = countOfCritical.find((o) => o.count === maxEvent);
  const matchFloor = matchedTags.find((i) => i.id === maxCritical.id);
  return matchFloor;
};
export const filterCriticalEvents = (allEvents) => {
  //    debugger;
  if (allEvents?.length > 0) {
    // Create a Set to store unique applicationIds
    const uniqueIds = new Set();
    // Filter out duplicates and add unique applicationIds to the Set
    allEvents.forEach((allEvents) => {
      uniqueIds.add(allEvents.applicationId);
    });
    // Convert Set back to an array and map over it to create options
    return Array.from(uniqueIds);
  } else {
    return [];
  }
};

export const getSiteName = (siteList, id) => {
  if (!Array.isArray(siteList) || siteList.length === 0 || id === "") {
    return "";
  }
  const found = siteList.find((s) => s.id === id);
  return found?.name || "";
};

export const getFilteredEvents = (site_id, allEvents) => {
  //debugger;

  const matchedTags = [];

  const deviceList = JSON.parse(sessionStorage.getItem("deviceList")) || [];
  const devicefilteredList = deviceList.find(({ tagids }) =>
    tagids?.some((tag) => tag === site_id)
  );

  if (!devicefilteredList) return allEvents;

  const matchedDevices = deviceList.filter(
    (d) => d.parentdeviceid === devicefilteredList.id
  );

  matchedDevices?.map((m) => {
    const event = allEvents?.find(({ evidences }) =>
      evidences.some(({ sourceId }) => sourceId === m.id)
    );
    if (event !== undefined) {
      matchedTags.push(event);
    }
  });

  console.log("getFilteredEvents", matchedTags, allEvents);
  return matchedTags.length > 0
    ? filterCriticalEvents(matchedTags)
    : filterCriticalEvents(allEvents);
  //return matchedTags;
};

export const getEventSites = (source_id, handleSiteOnclick) => {
  const matchedTags = [];
  const deviceList = JSON.parse(sessionStorage.getItem("deviceList")) || [];
  const parentDevice = deviceList.find(({ uid }) => uid === source_id);

  if (!parentDevice) return null;

  const dataList = deviceList.find(
    ({ id }) => id === parentDevice.parentdeviceid
  );

  if (!dataList || !dataList.tagids || dataList.tagids.length === 0)
    return null;

  const tagList = JSON.parse(sessionStorage.getItem("TagIdsList")) || [];

  dataList.tagids.map((id) => {
    const matchedTag = tagList.find(
      (tag) =>
        tag.id === id &&
        (tag.kind === "ts.tag.site" ||
          tag.kind === "ts.tag.subarea" ||
          tag.kind === "ts.tag.area" ||
          tag.kind === "ts.tag.floor")
    );
    //const matchedTag = tagList.find(tag => tag.id === id && tag.kind === "ts.tag.site");
    if (matchedTag) {
      matchedTags.push(matchedTag);
    }
  });
  const sortedArray = matchedTags.sort((a, b) => {
    const order = {
      "ts.tag.site": 1,
      "ts.tag.subarea": 2,
      "ts.tag.area": 3,
      "ts.tag.floor": 4,
    };

    return order[a.kind] - order[b.kind];
  });
  // console.log(sortedArray,"sortedArray")
  return sortedArray.length > 0 ? (
    <span>
      {sortedArray.flatMap((t) => t.name).join(", ")}
      <svg
        onClick={() => handleSiteOnclick(matchedTags[0].id)}
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.8,1.8a6.7138,6.7138,0,0,0-6.16418,9.36676c1.02069,2.197,6.217,8.63324,6.217,8.63324s4.70861-5.77271,6.007-8.48785a7.53134,7.53134,0,0,0,.65076-2.80158A6.71053,6.71053,0,0,0,10.8,1.8Zm5.04486,9.02679a54.25636,54.25636,0,0,1-4.991,7.169,63.17012,63.17012,0,0,1-5.18512-7.27466,5.58625,5.58625,0,1,1,10.7168-2.21057A6.4108,6.4108,0,0,1,15.84486,10.82679ZM10.8,5.175A3.375,3.375,0,1,0,14.175,8.55,3.375,3.375,0,0,0,10.8,5.175Zm0,5.625a2.25,2.25,0,1,1,2.25-2.25A2.25254,2.25254,0,0,1,10.8,10.8Z" />
      </svg>
    </span>
  ) : null;
};
export const getEventLocation = (source_id, handleEventOnclick, floorId) => {
  const matchedTags = [];
  const deviceList = JSON.parse(sessionStorage.getItem("deviceList")) || [];
  const parentDevice = deviceList.find(({ uid }) => uid === source_id);

  if (!parentDevice) return null;

  let dataList = deviceList.find(
    ({ id }) => id === parentDevice.parentdeviceid
  );

  if (!dataList || !dataList.tagids || dataList.tagids.length === 0)
    return null;

  const tagList = JSON.parse(sessionStorage.getItem("TagIdsList")) || [];

  let tagIds = dataList.tagids;
  if (floorId !== "") {
    tagIds = tagIds.includes(floorId) ? tagIds : [];
  }

  console.log("tagIds", tagIds);

  tagIds.map((id) => {
    const matchedTag = tagList.find(
      (tag) =>
        tag.id === id &&
        (tag.kind === "ts.tag.site" ||
          tag.kind === "ts.tag.subarea" ||
          tag.kind === "ts.tag.area" ||
          tag.kind === "ts.tag.floor")
    );
    if (matchedTag) {
      matchedTags.push(matchedTag);
    }
  });

  const sortedArray = matchedTags.sort((a, b) => {
    const order = {
      "ts.tag.site": 1,
      "ts.tag.subarea": 2,
      "ts.tag.area": 3,
      "ts.tag.floor": 4,
    };

    return order[a.kind] - order[b.kind];
  });
  // console.log(sortedArray,"sortedArray")
  const floor = matchedTags.find((m) => m.kind === "ts.tag.floor");
  console.log(sortedArray, "sorte");
  return sortedArray.length > 0 ? (
    <span>
      {sortedArray.flatMap((t) => t.name).join(", ")}
      <svg
        id="Ebene_1"
        onClick={() => handleEventOnclick(floor)}
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.8,1.8a6.7138,6.7138,0,0,0-6.16418,9.36676c1.02069,2.197,6.217,8.63324,6.217,8.63324s4.70861-5.77271,6.007-8.48785a7.53134,7.53134,0,0,0,.65076-2.80158A6.71053,6.71053,0,0,0,10.8,1.8Zm5.04486,9.02679a54.25636,54.25636,0,0,1-4.991,7.169,63.17012,63.17012,0,0,1-5.18512-7.27466,5.58625,5.58625,0,1,1,10.7168-2.21057A6.4108,6.4108,0,0,1,15.84486,10.82679ZM10.8,5.175A3.375,3.375,0,1,0,14.175,8.55,3.375,3.375,0,0,0,10.8,5.175Zm0,5.625a2.25,2.25,0,1,1,2.25-2.25A2.25254,2.25254,0,0,1,10.8,10.8Z" />
      </svg>
    </span>
  ) : null;
};

export const filterCameraListBasedOnTag = (cameraList, floorId) => {
  if (floorId === "" || floorId === undefined || floorId === null) {
    return cameraList;
  }
  return cameraList.filter(
    (c) => c?.customdata?.location?.floor?.tag === floorId
  );
  //return cameraList.filter((c) => c?.tagids && c?.tagids?.includes(floorId));
};

export const getEventsIconOnEventsTile = (name, isInfo = false) => {
  switch (name) {
    case "Restricted Area":
      return RestrictedAreaEventIcon;
    case "Door Open":
      return isInfo ? doorOpenBlue : DoorOpenEventIcon;
    case "Fire and smoke detected":
      return SmokeAndFireEventIcon;
    case "Bags remain in hallway":
      return ObjectDetectedEventIcon;
    default:
      return RestrictedAreaEventIcon; //for now we are giving a default case
  }
};
export const getBannerEventsIconOnEventsTile = (event) => {
  const { applicationId } = event;
  const objType = normalizeObjectType(event?.eventObjectDetail?.objectType);
  switch (applicationId) {
    case "PeopleDetection":
      return newCriticalPersonDetection;
    case "PeopleCountEE":
      return newCriticalPeopleCount;
    case "PeopleCountOA":
      return newCriticalPeopleCount;
    case "VehicleCountOA":
      return newCriticalVehiclecCount;
    case "VehicleCountEE":
      return newCriticalVehiclecCount;
    case "ParkingBayOccupancy":
      return newCriticalParkingoccupancy;
    case "ParkingBayOccupancyEE":
      return newCriticalParkingoccupancy;
    case "CrowdDensity":
      return newCriticalCrowdcounting;
    case "DwellTime":
      return newCriticalDwellTime;
    case "SlipAndFall":
      return newCriticalSlipFall;
    case "RestrictedAreaViolation":
      return newCriticalVehicleDetection;
    case "MissingPPE":
      return newCriticalPPE;
    case "ObjectDetection":
      return (objType && objectDetectionIcons?.orange?.[objType])
        ? objectDetectionIcons.orange[objType]
        : newCriticalObjectDetection;
    case "UnattendedObjectDetection":
      return newCriticalUnattendedObject;
    case "ProximityDetection":
      return newCriticalProximity;
    case "CameraAdjustment":
    case "CameraTampering":
      return newCriticalStreamMonitoring;
    default:
      return newCriticalPersonorVehicle;
  }
};
export const getEventsIconOnPriorityTile = (eventData, isHovered = false) => {
  const color = eventData?.priority?.toUpperCase() === "CRITICAL" ? "Orange" : eventData?.severity?.toUpperCase() === "CRITICAL" ? "Orange" : "";

  const cvAppname = eventData?.applicationId;
  const objectType = normalizeObjectType(eventData?.custom?.objectType);

  if (isHovered) {
    switch (cvAppname) {
      case "PeopleDetection":
        return peopleDetectionOrangeE;
      case "PeopleCountEE":
      case "PeopleCountOA":
        return peopleCountOrange;
      case "VehicleCountOA":
      case "VehicleCountEE":
        return vehicleCountOrange;
      case "ParkingBayOccupancy":
      case "ParkingBayOccupancyEE":
        return parkingOccupancyOrange;
      case "CrowdDensity":
        return crowdCountingOrange;
      case "DwellTime":
        return dwellTimeOrange;
      case "SlipAndFall":
        return slipAndFallOrangeE;
      case "RestrictedAreaViolation":
        return vehicleDetectionOrangeE;
      case "MissingPPE":
        return ppeOrange;
      case "ObjectDetection":
        return objectType
          ? objectDetectionIcons?.hover?.[objectType] || objectDetectionOrangeE
          : objectDetectionOrangeE;
      case "UnattendedObjectDetection":
        return unattendedObjectOrange;
      case "ProximityDetection":
        return proximityDetectionOrange;
      case "CameraAdjustment":
      case "CameraTampering":
        return streamMonitoringOrange;
      case "VehicleDetection":
        return vehicleDetectionOrangeE;
      default:
        return objectDetectionOrangeE;
    }
  }

  switch (cvAppname) {
    case "PeopleDetection":
      return color ? newCriticalPersonDetection : newMinorPersonDetection;
    case "PeopleCountEE":
      return color ? newCriticalPeopleCount : newMinorPeopleCount;
    case "PeopleCountOA":
      return color ? newCriticalPeopleCount : newMinorPeopleCount;
    case "VehicleCountOA":
    case "VehicleCountEE":
      return color ? newCriticalVehiclecCount : newMinorVehiclecCount;
    case "ParkingBayOccupancy":
    case "ParkingBayOccupancyEE":
      return color ? newCriticalParkingoccupancy : newMinorParkingoccupancy;
    case "CrowdDensity":
      return color ? newCriticalCrowdcounting : newMinorCrowdcounting;
    case "DwellTime":
      return color ? newCriticalDwellTime : newMinorDwellTime;
    case "SlipAndFall":
      return color ? newCriticalSlipFall : newMinorSlipFall;
    case "RestrictedAreaViolation":
    case "VehicleDetection": // VehicleDetection shares the vehicle icon with RestrictedAreaViolation
      return color ? newCriticalVehicleDetection : newMinorVehicleDetection;
    case "MissingPPE":
      return color ? newCriticalPPE : newMinorPPE;
    case "ObjectDetection":
      // Use newCriticalObjectDetection (56×56, same family as all other idle icons).
      // criticalObjectDetection is from EventIconsEBC (79×80) and renders smaller on the floor plan.
      return objectType
        ? color
          ? objectDetectionIcons?.orange?.[objectType] || newCriticalObjectDetection
          : objectDetectionIcons?.minor?.[objectType] || minorObjectDetection || CameraIconEBC
        : color
          ? newCriticalObjectDetection
          : minorObjectDetection || CameraIconEBC;
    case "UnattendedObjectDetection":
      return color ? newCriticalUnattendedObject : newMinorUnattendedObject;
    case "ProximityDetection":
      return color ? newCriticalProximity : newMinorProximity;
    case "CameraAdjustment":
    case "CameraTampering":
      return color ? newCriticalStreamMonitoring : newMinorStreamMonitoring;
    default:
      return CameraIconEBC;
  }
};

export const getNotificationIconImage = (notifyType) => {
  switch (notifyType) {
    case "critical":
      return ErrorNotificationIcon;
    case "info":
      return InfoNotificationIcon;
    default:
      return WarningNotificationIcon;
  }
};
